import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { Estampa, EstampasService } from 'src/app/services/comercio/estampas.service';

/**
 * ESTAMPA DEL COMERCIO (Mario, 12-oct; maqueta notas/liquidacion/maqueta-estampa-comercio.html; ESC-05): el avatar
 * redondo con el que se reconoce un comercio en toda la consola. Su logo si lo tiene; si no (o si no carga), sus
 * iniciales sobre su color. Con `conNombre`, al lado van el nombre y el código (y `sub`, si viene).
 *   <app-estampa-comercio [codigo]="v.comercio" [tam]="32" [conNombre]="true" sub="Crédito 9100024"></app-estampa-comercio>
 */
@Component({
  selector: 'app-estampa-comercio',
  templateUrl: './estampa-comercio.component.html',
  styleUrls: ['./estampa-comercio.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstampaComercioComponent implements OnChanges {
  @Input() codigo: string | null | undefined;
  @Input() tam: 20 | 24 | 32 | 48 = 24;
  @Input() conNombre = false;
  /** Lo que va debajo del nombre, después del código. */
  @Input() sub: string | null | undefined;
  /** El nombre que ya trae la pantalla (si la estampa todavía no llegó, se usa este). */
  @Input() nombre: string | null | undefined;

  e: Estampa | null = null;
  logoFallo = false;

  constructor(private estampas: EstampasService, private cd: ChangeDetectorRef) { }

  ngOnChanges(): void {
    this.logoFallo = false;
    const pedido = this.codigo;
    this.estampas.de(pedido).then((e) => { if (pedido === this.codigo) { this.e = e; this.cd.markForCheck(); } });
  }

  get titulo(): string { return this.e ? `${this.e.nombre} (${this.e.code})` : String(this.codigo || 'MT'); }
}
